import { Component,HostListener, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';


import { OwlOptions } from 'ngx-owl-carousel-o';
import { PopupService } from '../../services/popup.service';
import { convertNum, getParamWithoutCookie, SwapStatus } from '../../shared/constants/app-enums';
import { WalletConnectService } from '../../services/wallet-connect.service';
import { EventService } from '../../services/event.service';
import { environment } from '../../../environments/environment';
import { NoWalletComponent } from '../../modals/no-wallet/no-wallet.component';
import { ConnectComponent } from '../../modals/connect/connect.component';
import { ClaimComponent } from '../../modals/claim/claim.component';
import { ClaimService } from '../../services/claim.service';


@Component({
  selector: 'app-claim-widget',
  templateUrl: './claim-widget.component.html',
  styleUrls: ['./claim-widget.component.scss']
})

export class ClaimWidgetComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];

  lang: any = localStorage.getItem('currentlang');
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024;

  // modalRef?: BsModalRef;
  emailId = '';
  tokenSold = 0;
  totalTokens = 0;
  hashKey: string = '';
  windowSize: number = 0;
  usdRaised = 0;
  currentStep = 0;
  selectedLanguage: any;
  userStaked: number = 0;
  currentLanguage: any;
  connectInterval: any;
  usdtBal = 0;
  ethBal = 0;
  userClaimable: number = 0;
  userEthClaimable: number = 0;
  refreshId: any;
  refreshRate: number = 1000;
  dataLoaded: boolean = false;
  futureToken: number = 0;
  salePrice: number = 0.0337;
  liveCounter: any;
  isLive: boolean = true;
  claimMode: boolean = false;
  swapMode: string = 'native';
  isNative: boolean = true;
  isWert: boolean = false;
  showBW: boolean = false;
  isBsNetwork: boolean = false;
  endDate = 1734087600000;

  SwapStatus = SwapStatus;
  timeInterval: any;


  // claim states
  isClaimLive: boolean = true;


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024;
  }

  constructor(
    private translate: TranslateService,
    public modalRef: BsModalRef,
    private popupService: PopupService,
    private modalService: BsModalService,
    private claimService: ClaimService,
    private walletConnectService:WalletConnectService,
    private eventService: EventService,

  ) {
    // this.isClaimLive = this.walletConnectService.isClaimLive;
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
  
    // this.subscriptions.push(this.eventService.getEvent('CLAIM-LIVE').subscribe((val) => {
    //   this.isClaimLive = true;
    // }));

    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });
  }


  isClicked: boolean = false;


  ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang;
    this.isClicked = false;
    setTimeout(() => this.getBalanceData(), this.refreshRate);
  }

  ngAfterViewInit(): void {
    const bwUrl = getParamWithoutCookie('bwUrl');
    if (bwUrl && bwUrl != '') this.showBW = true;
  }

  getBalanceData() {
    const balanceData: any = this.claimService.balanceData;
    this.currentStep = balanceData.currentStep;
    this.tokenSold = balanceData.totalTokensSold;
    this.ethBal = balanceData.nativeBal;
    this.usdtBal = balanceData.usdtBal;
    this.usdRaised = balanceData.usdRaised;
    this.userClaimable = balanceData.userClaimable;
    this.userEthClaimable = balanceData.ethClaimable;
    this.userStaked = this.claimService.stakeData.userStaked;


    // this.isSoldOut = this.tokenSold > this.walletConnectService.tokenomics[this.walletConnectService.tokenomics.length - 1].maxToken ? true : false;
    // if (this.isSoldOut) {
    //   this.usdRaised = this.walletConnectService.tokenomics[this.currentStep].maxAmount;
    // }
    this.dataLoaded = true;

    // this.getFutureToken();
    if (this.refreshId) clearTimeout(this.refreshId);
    this.refreshId = setTimeout(() => this.getBalanceData(), this.refreshRate);
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static'
    });
  }

  convertNum(amount: number) {
    return convertNum(amount);
  }

  checkEthChain() {
    if (this.walletConnectService.isEthChain()) {
      return true;
    } else {
      this.popupService.messagePopup({icon:"info", title:this.translate.instant('popup.wrong_chain', { chainName: environment.eth.chainName}), desc: this.translate.instant('popup.change_network')});
      return false;
    }
  }
  

  // checkBscChaim() {
  //   if (!this.walletConnectService.isEthChain()) {
  //     return true;
  //   } else {
  //     this.popupService.messagePopup(
  //       "info",
  //       this.translate.instant('popup.wrong_chain', { chainName: environment.eth.chainName }),
  //       this.translate.instant('popup.change_network'))
  //       .then((res) => {
  //         if (res.isConfirmed) {
  //           this.walletConnectService.switchNetwork(environment.eth.chainIdInt);
  //         }
  //       });
  //     return false;
  //   }
  // }

  connectBestWallet() {
    console.log('connectBestWallet')
    if(!this.isClicked){
      console.log('ffffffffffffffffff')
      this.isClicked = true;
      this.walletConnectService.connectWallet("bw");
      setTimeout(()=> this.isClicked = false, 2000);
    }
  }

  get stakeData() {
    return this.claimService.stakeData;
  }

  get walletAddress(): any {
    return this.walletConnectService.walletAddress;
  }

  get tokenName() {
    return environment.tokenName;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  async claim() {
    if (this.userClaimable !== 0 && this.checkEthChain()) {
      this.claimService.claim(+(this.userClaimable));
      this.modalRef = this.modalService.show(ClaimComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
        initialState: { isClaim: true }
      });
    }
  }

  claimStake(): void {
    if (this.userClaimable == 0 || !this.checkEthChain()) return
    this.claimService.claimStake(+(this.userClaimable + this.userStaked));
    this.modalRef = this.modalService.show(ClaimComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
      initialState: { isStake: true }
    });
  }

  get modeName() {
    return this.claimService.getChainData().purchaseToken;
  }


  navigateToSection(section: string) {
    this.hashKey = section;
    if (section) {
      window.location.hash = section;
      // window.location.pathname = '/' + this.currentLanguage;
    }
  }

  connectWallet(mode: string): void {
    this.walletConnectService.connectWallet(mode, this.isBsNetwork);
    this.modalRef.hide();
  };

  disconnect(): void {
    this.walletConnectService.disConnectWallet();
  }

  openBestWallet() {
    this.modalRef.hide();
    setTimeout(()=> {
      this.modalRef = this.modalService.show(NoWalletComponent, {
        class: 'modal-lg modal-dialog-centered bw-modal',
        backdrop: 'static',
      });
    }, 500)
  }

}
